import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';

import { TerraIconModule } from '@ninety/terra';
import { ButtonComponent } from '@ninety/ui/core';
import { GridFilterBarActions } from '@ninety/web/pages/shared/layouts';

import { GridLayoutSelectors } from '../../../../grid-layout/_state/grid-layout-state.selectors';

@Component({
  selector: 'ninety-layout-actions-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonComponent, CommonModule, MatTooltipModule, MatButtonModule, TerraIconModule],
  template: `
    <div class="layout-actions-group">
      @if ((isEditing$ | async) === false) {
        <ninety-button
          filled
          primary
          id="edit-layout-button"
          class="action-btn"
          matTooltipClass="ninety-tooltip"
          matTooltip="Enables drag and drop as well as resizing of individual sections"
          (click)="onEnterEditLayoutMode()"
          [disabled]="(isGridInitialized$ | async) === false || isFetching">
          <terra-icon icon="edit" />
          Edit Layout
        </ninety-button>
      } @else {
        <button
          mat-raised-button
          class="action-btn layout-action-cancel"
          (click)="onCancelLayoutChanges()"
          data-cy="layout-actions-group_cancel-button">
          Cancel
        </button>
        <button
          mat-raised-button
          class="action-btn layout-action-save"
          color="accent"
          (click)="onClickSave()"
          data-cy="layout-actions-group_save-button">
          Save
        </button>
      }
    </div>
  `,
  styles: [
    `
      .layout-actions-group {
        display: flex;
        gap: 8px;
      }

      #edit-layout-button {
        margin-top: 2px;

        @media screen and (max-width: 1022px) {
          display: none;
        }
      }
    `,
  ],
})
export class LayoutActionsGroupComponent {
  private store = inject(Store);

  @Input() isFetching = false;

  isEditing$ = this.store.select(GridLayoutSelectors.selectIsLayoutModeEnabled);
  isGridInitialized$ = this.store.select(GridLayoutSelectors.selectIsGridInitialized);

  onEnterEditLayoutMode() {
    this.store.dispatch(GridFilterBarActions.enterLayoutMode());
  }

  onCancelLayoutChanges() {
    this.store.dispatch(GridFilterBarActions.cancelChanges());
  }

  onClickSave(): void {
    this.store.dispatch(GridFilterBarActions.requestPersistChanges());
  }
}
